export default function Skeleton({
    className = '',
    variant = 'text'
}: {
    className?: string;
    variant?: 'text' | 'rect' | 'circle'
}) {
    const baseClasses = 'skeleton';

    const variantClasses = {
        text: 'h-4 w-full rounded-md',
        rect: 'h-24 w-full rounded-xl',
        circle: 'h-12 w-12 rounded-full',
    };

    return (
        <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} />
    );
}
